import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { PgppButtonIconComponent } from '../../shared/components/button/button';
import { ButtonTypeEnum } from '../../core/enums/button-type.enum';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CadastroGestorModalComponent } from './cadastro-gestor-modal/cadastro-gestor-modal.component';
import { GlobalMessageService } from '../../shared/services/global-message.service';

@Component({
  selector: 'app-login.component',
  imports: [PgppButtonIconComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LoginComponent implements OnInit {
  router: Router = inject(Router);
  authService: AuthService = inject(AuthService);
  private modalService = inject(NgbModal);
  private globalMessageService = inject(GlobalMessageService);

  protected readonly ButtonType = ButtonTypeEnum;
  protected readonly abaLoginAtiva = signal<'pessoa-fisica' | 'cadastro-gestor'>(
    'pessoa-fisica',
  );

  ngOnInit(): void {
    const message = this.authService.getPendingLoginMessage();
    if (message) {
      this.globalMessageService.addMessage({
        type: 'danger',
        message,
        onDismiss: () => this.authService.clearPendingLoginMessage(),
      });
    }

    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
    }
  }

  login(): void {
    this.authService.clearPendingLoginMessage();
    this.authService.loginRedirect();
  }

  abrirBuscaMedicoIntercambista(): void {
    this.router.navigate(['/busca-medico-intercambista']);
  }

  selecionarAbaLogin(aba: 'pessoa-fisica' | 'cadastro-gestor'): void {
    this.abaLoginAtiva.set(aba);
  }

  abrirCadastroGestor(): void {
    this.modalService.open(CadastroGestorModalComponent, {
      centered: true,
      size: 'md',
      backdrop: 'static',
    });
  }

  abrirValidacaoDeclaracao(): void {
    this.router.navigate(['/validacao-declaracao']);
  }
}
